module.exports = __webpack_public_path__ + "static/snow-accumulation-legend-in-7c2583748385aeec2b6209b936e388b1.svg";